import InstagramLogoSrc from '@ui/assets/images/footer/instagram-logo.svg'
import LinkedInLogoSrc from '@ui/assets/images/footer/linked-in-logo.svg'
import FacebookLogoSrc from '@ui/assets/images/footer/facebook-logo.svg'

import { ROUTES } from '@app/constants'

export const footerMenuData = {
  forParents: {
    groupTitle: 'For Parents',
    links: [
      {
        id: 'aba-therapy',
        title: 'ABA Therapy',
        url: ROUTES.abaTherapy
      },
      {
        id: 'autism-diagnosis',
        title: 'Autism Diagnosis',
        url: ROUTES.autismDiagnosis
      },
      {
        id: 'our-locations',
        title: 'Our Locations',
        url: ROUTES.locations
      },
      {
        id: 'our-clinicians',
        title: 'Our Providers',
        url: ROUTES.ourClinicians
      },
      {
        id: 'learning-studio',
        title: 'Learning Studio',
        url: ROUTES.learningStudio
      },
      {
        id: 'm-chat-screening',
        title: 'M-CHAT Screening',
        externalLink: 'https://booking.elemy.com/test/mchat',
        url: '#'
      },
      {
        id: 'aba-cost-calculator',
        title: 'ABA Cost Calculator',
        url: ROUTES.abaCostCalculator
      },
      {
        id: 'faq',
        title: 'FAQ',
        url: ROUTES.faq
      }
    ]
  },
  forProviders: {
    groupTitle: 'For ABA Clinicians',
    links: [
      {
        id: 'join-us',
        title: 'Join Us',
        url: ROUTES.joinUs
      }
    ]
  },
  forPediatricians: {
    groupTitle: 'For Pediatricians',
    links: [
      {
        id: 'refer-a-patient',
        title: 'Refer a Patient',
        url: ROUTES.forPediatricians
      }
    ]
  },
  company: {
    groupTitle: 'Company',
    links: [
      {
        id: 'our-story',
        title: 'Our Story',
        url: ROUTES.ourStory
      },
      {
        id: 'corporate-careers',
        title: 'Corporate Careers',
        url: ROUTES.corporateCareers
      },
      {
        id: 'contact-us',
        title: 'Contact Us',
        url: ROUTES.contactUs
      }
    ]
  }
}

export const socials = [
  {
    id: 'instagram',
    imageSrc: InstagramLogoSrc,
    url: 'https://www.instagram.com/elemycare/',
    title: 'Instagram Logo'
  },
  {
    id: 'linked-in',
    imageSrc: LinkedInLogoSrc,
    url: 'https://linkedin.com/company/elemy-care/',
    title: 'LinkedIn Logo'
  },
  {
    id: 'facebook',
    imageSrc: FacebookLogoSrc,
    url: 'https://www.facebook.com/elemycare',
    title: 'Facebook Logo'
  }
]

export const legalLinks = [
  {
    id: 'privacy-policy',
    title: 'Privacy Policy',
    url: ROUTES.policy
  },
  {
    id: 'terms-and-conditions',
    title: 'Terms & Conditions',
    url: ROUTES.terms
  },
  {
    id: 'non-discrimination',
    title: 'Notice of Non-Discrimination',
    url: ROUTES.nonDiscrimination
  },
  {
    id: 'privacy-practices',
    title: 'Notice of Privacy Practices',
    url: ROUTES.privacyPractices
  }
]
